<template>
	<div class="form">
		<h4 class="step-title">When did you buy this home?</h4>
		<div class="step-content d-flex flex-column align-items-center">
			<scrollable-button-list
				v-bind:items="years"
				v-bind:onclick="complete"
				v-bind:value="lead.homeInsurance.yearHomeBought"
			/>
		</div>
	</div>
</template>

<script>
import ScrollableButtonList from "../shared/ScrollableButtonList.vue";

export default {
	name: "YearBought",
	components: {
		ScrollableButtonList,
	},
	props: {
		lead: Object,
	},
	computed: {
		years: function () {
			var years = [];

			var year = new Date().getFullYear();

			for (var i = 0; i < 122; i++) {
				years.push({ text: year, value: year });
				year--;
			}

			return years;
		},
	},
	methods: {
		complete: function (value) {
			this.lead.homeInsurance.yearHomeBought = value;
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
